import { Box, Divider, Flex, Text } from '@mantine/core'
import {
  CurrentTime,
  TimelineBox,
  type Timeline as TimelineProps,
  TimelineTime,
  TimelineWrapper,
  useTimeline,
} from '@nessprim/planby-pro'
import dayjs from 'dayjs'

import { useTranslation } from '@flecto/translations'

export function Timeline(props: TimelineProps) {
  const { i18n } = useTranslation('saas', { keyPrefix: 'schedule' })

  const {
    getCurrentTimeProps,
    getTime,
    getTimelineProps,
    time,
    timelineHeight,
  } = useTimeline(props)

  const {
    dayWidth,
    isBaseTimeFormat,
    isCurrentTime,
    isTimelineVisible,
    isToday,
    isVerticalMode,
  } = props

  const daySize = dayWidth / time.length

  const renderTime = (item: number | string, index: number) => {
    const { isNewDay, time } = getTime(item)
    const position = { left: daySize * index, width: daySize }
    const isVisible = isTimelineVisible(position)
    const isToday = dayjs(time).isSame(dayjs(), 'day')

    if (!isVisible) {
      return null
    }

    const dateLabel = (
      <>
        {dayjs(time).locale(i18n.language).format('ddd')}
        &nbsp;
        {dayjs(time).locale(i18n.language).format('DD')}
      </>
    )

    return (
      <TimelineBox
        isCurrentTime={isCurrentTime}
        isToday={isToday}
        isVerticalMode={isVerticalMode}
        key={index}
        timelineHeight={timelineHeight}
        {...position}
        className='planby-timeline-box'
      >
        <TimelineTime
          className='planby-timeline-time'
          isBaseTimeFormat={isBaseTimeFormat}
          isNewDay={isNewDay}
          isVerticalMode={isVerticalMode}
        >
          <Flex align='center' h='100%' justify='space-between'>
            <Flex align='center' h='100%' justify='center' w='100%'>
              {isToday ? (
                <Box
                  bg='brand.1'
                  c='brand.7'
                  px={10}
                  py='xs'
                  style={{ borderRadius: 'var(--mantine-radius-sm)' }}
                >
                  <Text fw={500} size='sm' tt='capitalize'>
                    {dateLabel}
                  </Text>
                </Box>
              ) : (
                <Text c='dimmed' fw={500} size='sm' tt='capitalize'>
                  {dateLabel}
                </Text>
              )}
            </Flex>
            <Divider
              color='gray.3'
              h={24}
              mt={20}
              orientation='vertical'
              size='xs'
            />
          </Flex>
        </TimelineTime>
      </TimelineBox>
    )
  }

  return (
    <TimelineWrapper
      {...getTimelineProps()}
      className='planby-timeline-wrapper'
    >
      {isCurrentTime && isToday && <CurrentTime {...getCurrentTimeProps()} />}
      {time.map((item, index) => renderTime(item, index))}
    </TimelineWrapper>
  )
}
